<template>
  <div class="submitted-offers-combined container-fluid">
    <div class="row title-row">
      <div class="col-6">Selected {{titleType}}</div>
      <div class="col-6" v-if="consumer">
        <Progress :currentValue="pendingRequests.length" :maxValue="progressMax"></Progress>
      </div>
    </div>
    <div class="row offers-row">
      <!-- <SubmittedOfferSmall class="col-12" v-for="(offer, index) in submits" :class="{ last: index === submits.length-1 && pendingRequests.length === 0 }" :key="offer.offer.displayedOfferId ?? offer.offer.id" :offer="offer"></SubmittedOfferSmall> -->
      <BulkPendingOffer class="col-12" v-for="(request, index) in pendingRequests" :class="{ last: index === pendingRequests.length-1 }" :key="request.offer.displayedOfferId" :offer="request.offer" :submitting="submitting" @cancelOffer="cancelOffer(request)"></BulkPendingOffer>
      <div class="col-12 no-submitted-offers" v-show="pendingRequests.length === 0">
        Currently no selected offers.
      </div>
    </div>
    <div class="row bulk-submit-button-row" v-show="pendingRequests.length > 0 && !submitting">
      <div class="col-12 text-center">
        <button class="btn btn-success" @click="submitAll">Submit All</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import BulkPendingOffer from './mini-offers/BulkPendingOffer.vue'
import Progress from '../basic-elements/Progress.vue'

export default {
  name: 'BulkSubmitList',
  props: ['type'],
  emits: ['submitAll', 'cancelOffer'],
  components: {
    Progress,
    BulkPendingOffer
  },
  data () {
    return {
      savedProgressMax: 0
    }
  },
  computed: {
    progressMax () {
      return this.submitting ? this.savedProgressMax : this.consumer.max_offer_submission - this.successfulSubmits.length
    },
    successfulSubmits () {
      return this.submits.filter((offer) => offer.status === 'Accepted')
    },
    titleType () {
      return this.type ?? 'Schools'
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      pendingRequests: state => state.consumer.leadRequests.pendingBulkSubmits,
      submitting: state => state.consumer.leadRequests.submittingBulk
    }),
    ...mapGetters({
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  methods: {
    submitAll () {
      this.$emit('submitAll')
    },
    cancelOffer (pendingSubmit) {
      this.$emit('cancelOffer', pendingSubmit)
    }
  },
  mounted () {
    this.savedProgressMax = this.consumer.max_offer_submission - this.successfulSubmits.length
  },
  watch: {
    submitting (newVal) {
      this.savedProgressMax = this.progressMax
    }
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.submitted-offers-combined {
  border: 1px solid #d6e9c6;
  margin-bottom: 20px;
  border-radius: .25em;
}
.submitted-offers-combined .title-row {
  padding: 20px 0;
  border-bottom: 1px solid #d6e9c6;
  color: #3c763d;
  background-color: #dff0d8;
}
.submitted-offer-small {
  border-bottom: 1px solid #ddd;
  min-height: 56px;
}
.submitted-offer-small.last {
  border: none;
}
.no-submitted-offers {
  padding-top: 10px;
  padding-bottom: 25px;
}
.bulk-submit-button-row {
  padding-top: 15px;
  padding-bottom: 15px;
}
@media screen and (min-width: 1200px) {
  .submitted-offer-small {
    padding-left: calc(var(--bs-gutter-x));
  }
}
</style>
